window.addEventListener('touchstart', function onFirstTouch() {
  window.IS_TOUCH_DEVICE = true
  window.removeEventListener('touchstart', onFirstTouch, false)
}, false)
